export default function FormataTitulo(nome){
    switch(nome){
        case "titulo":
            return "Título"
        case "aluno":
            return "Aluno"
        case "emprestimo":
            return "Empréstimo"
        case "status":
            return "Status"
        case "devolucao":
            return "Devolução"
        case "acoes":
            return "Ações"
        case "autor":
            return "Autor"
        case "genero":
            return "Gênero"
        case "disponibilidade":
            return "Acervo"
        case "acervo":
            return "Acervo"
        case "localizacao":
            return "Localização"
        case "num_emprestimo":
            return "N° Empréstimo"
        case "telefone":
            return "Telefone"
        case "pontuacao":
            return "Pontuação"
        case "turma":
            return "Turma"
        case "email":
            return "Email"
        default:
            return ""
    }
}
